export const focusTraps = {
  SERIES_DATE_PICKER: 'series-date-picker',
  TICKET_PICKER: 'ticket-picker'
};
